import React from 'react'

const Error = () => (
  <div>Feil</div>
)

export default Error
